import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';
import { SHARED_MODULES } from '../../../../shared.';
import { ThousandSeparatorPipe } from '../../../pipes/thousand-separator.pipe';

export const ELEMENT = new InjectionToken<string>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

@Component({
    selector: 'app-number-dtype',
    templateUrl: 'number-dtype.component.html',
    styleUrls: ['number-dtype.component.scss'],
	imports: [SHARED_MODULES, ThousandSeparatorPipe],
    standalone: true
})
export class NumberDtypeComponent implements OnInit {
	element: number;
	isNegativeHighlight: boolean = false;
	isTooltip: boolean = false;

	constructor(@Inject(ELEMENT) private elementInjected: IInjectedElementDtype<number>) {}

	ngOnInit(): void {
		this.element = this.elementInjected.element;
		this.isNegativeHighlight = this.elementInjected.isNegativeHighlight;
		this.isTooltip = this.elementInjected.isTooltip;
	}
}
